export default "__VITE_ASSET__B45jOiEZ__"